import { QueryCache, QueryClient } from 'react-query';

export const queryClient = new QueryClient({ queryCache: new QueryCache() });
queryClient.setQueryDefaults('*', { staleTime: 10000 });
